module.exports = __webpack_public_path__ + "static/img/288_TO8_2450.d7edab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/288_TO8_2450.jpg
// module id = eUYJ
// module chunks = 0